module.exports = __webpack_public_path__ + "img/yup.70926512.gif";